/** @format */

import React, { useState, useEffect, useRef } from "react";

import SecureStorage from "react-secure-storage";

import Flood from "../assets/icon/Flood.png";
import Drought from "../assets/icon/Drought.png";
import Windstorm from "../assets/icon/Windstorm.png";
import Cold from "../assets/icon/Cold.png";
import Wildfire from "../assets/icon/Wildfire.png";
import Fire from "../assets/icon/Fire.png";
import Earthquake from "../assets/icon/Earthquake.png";
import Mudslide from "../assets/icon/Mudslide.png";
import Collapsed_Building from "../assets/icon/Collapsed-Building.png";
import Transport_Disaster from "../assets/icon/Transport-Disaster.png";
import Chemical_Disaster from "../assets/icon/Chemical-Disaster.png";
import Hazardous_Material from "../assets/icon/Hazardous-Material.png";
import Unrest from "../assets/icon/Unrest.png";
import Road_Disaster from "../assets/icon/Road-Disaster.png";
import Other from "../assets/icon/Other.png";

const constants = require("file-configs/constants");

// export const getDataDropdownProblemTypeOther = async () => {
//   const options = [
//     { id: 1, name: "อื่นๆ" },
//     { id: 2, name: "ไฟฟ้า" },
//     { id: 3, name: "น้ำท่วม" },
//   ];

//   return options;
// };

export const getDataDropdownProblemType = async (lang) => {
  let options = [];
  if (lang != "ENG") {
    options = [
      { level: 1, name: "อุทกภัย", photo: Flood },
      { level: 2, name: "ภัยแล้ง", photo: Drought },
      { level: 3, name: "วาตภัย", photo: Windstorm },
      { level: 4, name: "ภัยหนาว", photo: Cold },
      { level: 5, name: "ไฟป่า", photo: Wildfire },
      { level: 6, name: "อัคคีภัย", photo: Fire },
      { level: 7, name: "แผ่นดินไหว", photo: Earthquake },
      { level: 8, name: "ดินโคลนถล่ม", photo: Mudslide },
      { level: 9, name: "อาคารถล่ม", photo: Collapsed_Building },
      { level: 10, name: "ภัยคมนาคมขนส่ง", photo: Transport_Disaster },
      { level: 11, name: "ภัยสารเคมี", photo: Chemical_Disaster },
      { level: 12, name: "วัตถุอันตราย", photo: Hazardous_Material },
      { level: 13, name: "ภัยความไม่สงบ", photo: Unrest },
      { level: 14, name: "ภัยทางถนน", photo: Road_Disaster },
      { level: 15, name: "ภัยอื่นๆ", photo: Other },
    ];
  } else {
    options = [
      { level: 1, name: "Flood", photo: Flood },
      { level: 2, name: "Drought", photo: Drought },
      { level: 3, name: "Windstorm", photo: Windstorm },
      { level: 4, name: "Cold", photo: Cold },
      { level: 5, name: "Wildfire", photo: Wildfire },
      { level: 6, name: "Fire", photo: Fire },
      { level: 7, name: "Earthquake", photo: Earthquake },
      { level: 8, name: "Mudslide", photo: Mudslide },
      { level: 9, name: "Collapsed Building", photo: Collapsed_Building },
      { level: 10, name: "Transport Disaster", photo: Transport_Disaster },
      { level: 11, name: "Chemical Disaster", photo: Chemical_Disaster },
      { level: 12, name: "Hazardous Material", photo: Hazardous_Material },
      { level: 13, name: "Unrest", photo: Unrest },
      { level: 14, name: "Road Disaster", photo: Road_Disaster },
      { level: 15, name: "Other", photo: Other },
    ];
  }

  return options;
};

export const getOrg = async (lat, lon) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
        // Authorization:
        // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyOTE5LCJ1c2VybmFtZSI6IlU0ZmEwZjM3ZGQzZjU1NzdmYWIwNDJmZTljZjFjZWFmNCIsImV4cCI6MTY4MjMyMjYwNywiZW1haWwiOiJVNGZhMGYzN2RkM2Y1NTc3ZmFiMDQyZmU5Y2YxY2VhZjRAbWFpbC5jb20iLCJvcmlnX2lhdCI6MTY4MTExMzAwN30.nGeogR0cy46IBYSNfoo8SxB0EbzW89NiGODWzjlrK-Y",
      },
      body: JSON.stringify({
        lat: lat,
        lon: lon,
        privacy: "all",
        // show_in_chatbot: true,
      }),
    };

    const response = await fetch(
      constants.APITRAFFY + "/org/responsible_org/?limit=5000]",
      requestOptions,
    );

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("getOrg fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const getProblemType = async (lang) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
        // Authorization:
        // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyOTE5LCJ1c2VybmFtZSI6IlU0ZmEwZjM3ZGQzZjU1NzdmYWIwNDJmZTljZjFjZWFmNCIsImV4cCI6MTY4MjMyMjYwNywiZW1haWwiOiJVNGZhMGYzN2RkM2Y1NTc3ZmFiMDQyZmU5Y2YxY2VhZjRAbWFpbC5jb20iLCJvcmlnX2lhdCI6MTY4MTExMzAwN30.nGeogR0cy46IBYSNfoo8SxB0EbzW89NiGODWzjlrK-Y",
      },
    };

    let response = await fetch(
      constants.APITRAFFY +
        "/org/fondue-problem-custom/?limit=1000&fondue_group=8662" +
        "&lang=" +
        lang,
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "getOrg error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("getProblemType fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const checkCasePassword = async (ticket_id, password) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
      },
    };

    // /fondue-cases-api/get_case/
    let response = await fetch(
      constants.APITRAFFY +
        "/fondue-cases-api/get_case/?ticket_id=" +
        ticket_id +
        "&p=" +
        password,
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "getOrg error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("checkCasePassword fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const sendData = async (
  description,
  problem_type,
  photo,
  lat,
  lng,
  org_id,
  phone,
  email,
  lang,
) => {
  // console.log('send data',{
  //   token_secret_key: "VYQBNPJV",
  //   description: description,
  //   topic_id: problem_type.id,
  //   photo_base64: [photo],
  //   latitude: lat,
  //   longitude: lng,
  //   org_id: org_id,
  //   reporter_phone: phone,
  //   reporter_email: email,
  //   lang: lang
  // });

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDA3LCJ1c2VybmFtZSI6ImRkcG1yZXBvcnQiLCJleHAiOjE4NTkyNTcyMjUsImVtYWlsIjoiZGRwbXJlcG9ydEBnbWFpbC5jb20iLCJvcmlnX2lhdCI6MTc2NDY0OTIyNSwiZXhjaGFuZ2Vfa2V5IjoiMWViNDNkYWI5MzkwNGEwN2I5MmVjNzY2NWUxMDU5M2YxZWNkMWQ4ZWMxOWUzZTc2N2FmMmNjNGUyMGVjZGE2YSIsInRva2VuX2lkIjoyMywiZXhwaXJlX3RpbWVzdGFtcCI6MTg1OTI1NzIyNX0.dNZ1LF_Ktbya7ayWPntGn3xuEwDPYQcnDJLLTwDervk",
    },
    body: JSON.stringify({
      description: description,
      topic_id: problem_type.id,
      photo_base64: [photo],
      latitude: lat,
      longitude: lng,
      org_id: org_id,
      reporter_phone: phone,
      reporter_email: email,
      lang: lang,
    }),
  };

  let response = await fetch(
    "https://publicapi.traffy.in.th/exchange-api/new-issue/v1",
    requestOptions,
  );

  let data = await response.json();
  // console.log('data',data);

  return data;
};
